module.exports = __webpack_public_path__ + "static/media/sofie_danish.3a709dbf.mp3";